import React, { FC, useCallback } from 'react';

import { ITemplateCardConfig } from '../../../../../types/templates';
import { ClaimLinkTemplatesInfiniteList } from '../../../../TemplatesComponent';
import { useFilters } from '../Filters/useFilters';
import { useClaimLinkTemplatesInfiniteQuery } from '../hooks/useClaimLinkTemplatesInfiniteQuery';
import { ModalBodyShell } from './ModalBodyShell';
import { ModalFooter } from './ModalFooter';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  hasSelection: boolean;
  cardConfig: ITemplateCardConfig;
  departmentId?: string;
  orgId?: string;
  withFooterActions?: boolean;
}

export const InfiniteTemplatesBody: FC<IProps> = ({
  isOpen,
  onClose,
  onSubmit,
  hasSelection,
  cardConfig,
  departmentId,
  orgId,
  withFooterActions = false,
}) => {
  const {
    Filters,
    filtersRef,
    filters: { query: filtersQuery, selectedDepartments: filtersSelectedDepartments },
    getSubmitDisabled,
  } = useFilters({
    onSubmit,
    hasSelection,
    departmentId,
    orgId,
    showActionButton: false,
  });

  const {
    templates,
    totalCount,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isFetchedAfterMount,
    isError,
    refetch,
    fetchNextPage,
  } = useClaimLinkTemplatesInfiniteQuery({
    searchQuery: filtersQuery,
    selectedDepartments: filtersSelectedDepartments,
    departmentId,
    orgId,
    enabled: isOpen,
  });

  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);

  const hasFiltersApplied = Boolean(filtersQuery || filtersSelectedDepartments?.length);

  return (
    <React.Fragment>
      <ModalBodyShell filters={Filters}>
        <ClaimLinkTemplatesInfiniteList
          templates={templates}
          isLoading={isFetching || !isFetchedAfterMount}
          isFetchingMore={isFetchingNextPage}
          hasNextPage={hasNextPage}
          isError={isError}
          onRetry={handleRetry}
          onLoadMore={fetchNextPage}
          cardConfig={cardConfig}
          hasFiltersApplied={hasFiltersApplied}
          filtersRef={filtersRef}
        />
      </ModalBodyShell>
      {withFooterActions && (
        <ModalFooter onCancel={onClose} onDone={onSubmit} isDoneDisabled={getSubmitDisabled(totalCount)} />
      )}
    </React.Fragment>
  );
};
